// Soft Web Audio chimes (no file download). Silent until the page has had a user gesture.
const MUTE_KEY = "tycc_chime_muted";
const VOLUME_KEY = "tycc_chime_volume";
export const VOLUMES = { soft: 0.08, medium: 0.18, loud: 0.38 };
export const isChimeMuted = () => localStorage.getItem(MUTE_KEY) === "1";
export const setChimeMuted = (on) => localStorage.setItem(MUTE_KEY, on ? "1" : "0");
export const getChimeVolume = () => (VOLUMES[localStorage.getItem(VOLUME_KEY)] ? localStorage.getItem(VOLUME_KEY) : "medium");
export const setChimeVolume = (level) => localStorage.setItem(VOLUME_KEY, VOLUMES[level] ? level : "medium");

let ctx = null;
const play = (notes, scale = 1) => {
  if (isChimeMuted()) return false;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume();
    if (ctx.state !== "running") return false;
    const peak = VOLUMES[getChimeVolume()] * scale;
    const t0 = ctx.currentTime;
    notes.forEach(([freq, at, len]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t0 + at);
      gain.gain.exponentialRampToValueAtTime(peak, t0 + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + at + len);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0 + at);
      osc.stop(t0 + at + len + 0.05);
    });
    return true;
  } catch { return false; }
};

// Two-note "bamboo" chime (~0.6s) when queued progress reaches the cloud
export const playChime = () => play([[659.25, 0, 0.55], [987.77, 0.18, 0.55]]);
// Tiny "heart pop" (~0.25s, quieter) when a queued cheer / thank-you lands
export const playPop = () => play([[880, 0, 0.12], [1174.66, 0.09, 0.16]], 0.6);
// Four-note ascending jingle (~0.8s) when a new sticker unlocks
export const playJingle = () => play([[523.25, 0, 0.3], [659.25, 0.15, 0.3], [783.99, 0.3, 0.3], [1046.5, 0.45, 0.45]]);
